var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlassOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-448 15304)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(447 -15302)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.055,169.279a6.01,6.01,0,0,0-1.871-3.78,5.952,5.952,0,0,0-9.787,2.738,2.754,2.754,0,0,0-3.793,0,5.958,5.958,0,0,0-9.787-2.745,6.042,6.042,0,0,0-1.871,3.787H32v1.165h.945a6.01,6.01,0,0,0,1.871,3.78,5.959,5.959,0,0,0,10.021-4.356v-.006a1.689,1.689,0,0,1,3.327,0v.006a5.959,5.959,0,0,0,10.021,4.356,6.026,6.026,0,0,0,1.871-3.787H61v-1.165h-.945Zm-5.929,5.567a4.984,4.984,0,1,1,4.984-4.984A4.991,4.991,0,0,1,54.125,174.846Zm-15.251,0a4.984,4.984,0,1,1,4.984-4.984A4.991,4.991,0,0,1,38.875,174.846Z",
    transform: "translate(419 -15456.9)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassOn);
export default __webpack_public_path__ + "static/media/glassON.0d48c02d10e79fe5c13ab4e3c87b439a.svg";
export { ForwardRef as ReactComponent };